import { Trainer } from "./trainer"

export const ClimbingWall = ({ trainers, selectedDate }) => {
  return (
    <div className='row'>
      {trainers?.map(el => (
        <Trainer trainer={el} key={el.trainer_ID} type={'Скалодром'} initialDate={selectedDate} />
      ))}
    </div>
  )
}
